import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import '../../Platform/UserName/UserName.scss';



const ConfirmBox = (props) => {
    const { show, handleClose, sellOut} = props;

    


    

    return (
    
        <Dialog  open={show} onBackdropClick={handleClose}>
        <div className="walletContentPop">
            <div className="walletTitle">
              <div className="title">Confirm Action</div>
              <button onClick={handleClose}>X</button>
            </div>
            <form>
              <div style={{padding:"0 20px 0 20px"}}>
                 Do you really want to initiate Token sellout?
              </div>
              <div className="confirmButton">
                <button type="button" className="cancel" onClick={handleClose}>CANCEL</button>
                <button type="submit" className="confirm" onClick={sellOut}>CONFIRM</button>
              </div>
            </form>
        </div>
      </Dialog>
     
        );
    }
    
    export default ConfirmBox;